import React from 'react';
import { FaFilter, FaChevronDown } from 'react-icons/fa';

const selectClass =
  'w-full px-4 py-2 bg-gray-50 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-all cursor-pointer appearance-none pr-8';

const labelClass = 'flex items-center gap-1.5 text-xs font-semibold text-gray-600 dark:text-gray-400 mb-1.5';

const SelectWrapper = ({ children }) => (
  <div className="relative">
    {children}
    <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
      <FaChevronDown className="w-3 h-3" />
    </div>
  </div>
);

const ClientFilters = ({
  stepFilter,
  setStepFilter,
  serviceFilter,
  setServiceFilter,
  paymentFilter,
  setPaymentFilter,
}) => {
  return (
    <div className="bg-white dark:bg-neutral-900 rounded-2xl shadow-card border border-gray-100 dark:border-neutral-800 mb-4">
      <div className="px-5 py-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          
          {/* Service Filter */}
          <div>
            <label className={labelClass}>
              <FaFilter className="w-3 h-3 text-primary-500" /> Services
            </label>
            <SelectWrapper>
              <select value={serviceFilter} onChange={(e) => setServiceFilter(e.target.value)} className={selectClass}>
                <option value="all">All Services</option>
                <option value="usa">USA Company</option>
                <option value="tax">Tax Filing</option>
                <option value="bookkeeping">Bookkeeping</option>
                <option value="cfo">CFO Advisory</option>
                <option value="registeredAgent">Registered Agent</option>
              </select>
            </SelectWrapper>
          </div>

          {/* Step Filter */}
          <div>
            <label className={labelClass}>
              <FaFilter className="w-3 h-3 text-primary-500" /> Filter by Step
            </label>
            <SelectWrapper>
              <select value={stepFilter} onChange={(e) => setStepFilter(e.target.value)} className={selectClass}>
                <option value="all">All Steps</option>
                <optgroup label="Total Status">
                  <option value="total-in-progress">Total In-Progress</option>
                  <option value="total-completed">Total Completed</option>
                  <option value="total-pending">Total Pending</option>
                </optgroup>
                <optgroup label="Step 1">
                  <option value="step1-in-progress">Step 1 In-Progress</option>
                  <option value="step1-completed">Step 1 Completed</option>
                  <option value="step1-pending">Step 1 Pending</option>
                </optgroup>
                <optgroup label="Step 2">
                  <option value="step2-in-progress">Step 2 In-Progress</option>
                  <option value="step2-completed">Step 2 Completed</option>
                  <option value="step2-pending">Step 2 Pending</option>
                </optgroup>
                <optgroup label="Step 3">
                  <option value="step3-in-progress">Step 3 In-Progress</option>
                  <option value="step3-completed">Step 3 Completed</option>
                  <option value="step3-pending">Step 3 Pending</option>
                </optgroup>
                <optgroup label="Step 4">
                  <option value="step4-in-progress">Step 4 In-Progress</option>
                  <option value="step4-completed">Step 4 Completed</option>
                  <option value="step4-pending">Step 4 Pending</option>
                </optgroup>
              </select>
            </SelectWrapper>
          </div>

          {/* Payment Status Filter */}
          <div>
            <label className={labelClass}>
              <FaFilter className="w-3 h-3 text-primary-500" /> Payment Status
            </label>
            <SelectWrapper>
              <select value={paymentFilter} onChange={(e) => setPaymentFilter(e.target.value)} className={selectClass}>
                <option value="all">All</option>
                <option value="paid">Paid</option>
                <option value="unpaid">Unpaid</option>
                <option value="wip-unpaid">WIP–Unpaid</option>
                <option value="p-extension">P Extension</option>
                <option value="up-extension">UP Extension</option>
              </select>
            </SelectWrapper>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ClientFilters;
